import { createApp } from 'vue'
import App from './App.vue'
import setupRouter from './router/index'
import { i18n } from './i18n'
import { createPinia } from 'pinia'
import clickOutsideDirective from './utils/click-outside';

import './assets/styles/main.scss'
// import plausibleGlobal from './utils/plausibleGlobal'
const pinia = createPinia()
const app = createApp(App)
const router = setupRouter(i18n)
app.directive('click-outside', clickOutsideDirective);
app.use(i18n)
  .use(pinia)
  .use(router)
  // .use(plausibleGlobal)
  .mount('#app')
